/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_Organizers_LabelInputs */



/**
* | output |
* | --- |
* | "Organizers" |
*
* @param {League_Organizers_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_organizers_label = /** @type {((inputs?: League_Organizers_LabelInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_Organizers_LabelInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Organisateurs")
	if (locale === "es") return /** @type {LocalizedString} */ ("Organizadores")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Organizadores")
	if (locale === "it") return /** @type {LocalizedString} */ ("Organizzatori")
	return /** @type {LocalizedString} */ ("Organizers")
});